import {useEffect, useRef} from 'react';

export const useResetAnalyticsOnLogout = (
  isLoggedIn: boolean,
  reset: () => void,
) => {
  const wasLoggedInRef = useRef(isLoggedIn);

  useEffect(() => {
    if (wasLoggedInRef.current && !isLoggedIn) {
      reset();
    }
    wasLoggedInRef.current = isLoggedIn;
  }, [isLoggedIn, reset]);
};
